import { SportsApiClient, LeaguesApiClient, EventsApiClient } from "./BFFGatewayClient";
import { GlobalConfig } from '../../../../configuration';
import { BFFGatewayConfiguration } from './BFFGatewayConfiguration';
import { AjaxService } from '../../../../helpers';
export { EventsBySportIdRequest, EventsByLeagueIdRequest, EventsFromTopLeaguesBySportIdRequest, SportsRequest } from "sbtech-online-sportcontent";
/**
 * BFFGateway class provides interface for communication between BFF service and blocks.
 *
 * sbRespLib.GlobalConfig object need to be init before using BFFGateway
 * as base URL for BFF is present from config.
 *
 * example usage:
 * var gateway = new sbRespLib.BFFGateway();
 * gateway.getSports({ ... });
 *
 */
var BFFGateway = /** @class */ (function () {
    function BFFGateway() {
        var config = new BFFGatewayConfiguration({
            accessToken: GlobalConfig
                .getAuthorization()
                .token,
            basePath: GlobalConfig.apiConfigs.bffApiUrl
        });
        var service = new AjaxService();
        this.sportsApiClient = new SportsApiClient(config, service);
        this.leaguesApiClient = new LeaguesApiClient(config, service);
        this.eventsApiClient = new EventsApiClient(config, service);
    }
    /**
     * Get BFF request configuration from GlobalConfig
     * @return token from GlobalConfig
     */
    BFFGateway.prototype.getGlobalConfigToken = function () {
        return GlobalConfig
            .getAuthorization()
            .token;
    };
    //Event endpoints
    /**
     * Request events by sport id
     * @param request EventsBySportIdRequest
     */
    BFFGateway.prototype.getEventsBySportId = function (request) {
        this
            .eventsApiClient
            .refreshToken(this.getGlobalConfigToken());
        return this
            .eventsApiClient
            .getBySportId(request);
    };
    /**
     * Request events by event ids
     * @param request EventsByEventIdRequest
     */
    BFFGateway.prototype.getEventsByEventId = function (request) {
        this
            .eventsApiClient
            .refreshToken(this.getGlobalConfigToken());
        return this
            .eventsApiClient
            .getByEventsId(request);
    };
    /**
     * Request events by league ids
     * @param request EventsByLeagueIdRequest
     */
    BFFGateway.prototype.getEventsByLeagueId = function (request) {
        this
            .eventsApiClient
            .refreshToken(this.getGlobalConfigToken());
        return this
            .eventsApiClient
            .getByLeaguesId(request);
    };
    /**
     * Request events from top leagues by sport id
     * @param request EventsFromTopLeaguesBySportIdRequest
     */
    BFFGateway.prototype.getEventsFromTopLeaguesBySportId = function (request) {
        this
            .eventsApiClient
            .refreshToken(this.getGlobalConfigToken());
        return this
            .eventsApiClient
            .getFromTopLeaguesBySportId(request);
    };
    //Leagues endpoints
    /**
     * Request all leagues by sport ids
     * @param request LeaguesBySportIdRequest
     */
    BFFGateway.prototype.getLeaguesBySportId = function (request) {
        this
            .leaguesApiClient
            .refreshToken(this.getGlobalConfigToken());
        return this
            .leaguesApiClient
            .getBySportId(request);
    };
    /**
     * Request all top leagues by sport id
     * @param request TopLeaguesBySportIdRequest
     */
    BFFGateway.prototype.getTopLeaguesBySportId = function (request) {
        this
            .leaguesApiClient
            .refreshToken(this.getGlobalConfigToken());
        return this
            .leaguesApiClient
            .getTopLeaguesBySportId(request);
    };
    //Sports endpoints
    /**
     * Request all sports
     * @param request SportsRequest
     */
    BFFGateway.prototype.getSports = function (request) {
        this
            .sportsApiClient
            .refreshToken(this.getGlobalConfigToken());
        return this
            .sportsApiClient
            .getAllSports(request);
    };
    /**
     * Get sports grouped by Date from BFF
     * @param {request} SportsGroupedByDateRequest
     * @throws {RequiredError}
     * @memberof SportsApiClient
     */
    BFFGateway.prototype.getSportsGroupedByDate = function (request) {
        this.sportsApiClient.refreshToken(this.getGlobalConfigToken());
        return this.sportsApiClient.getSportsGroupedByDate(request);
    };
    return BFFGateway;
}());
export { BFFGateway };
//# sourceMappingURL=BFFGateway.js.map